import { graphql, Link } from "gatsby"
import React from "react"

import Layout from "../components/layout/index"
import SEO from "../components/seo"
import { rhythm } from "../utils/typography"
import { post as PostMappers } from "../utils/mappers"
import PostList from "../components/post/post-list"

const tagTemplateStyles = {
  headerStyle: { textAlign: "center" },
  titleStyle: {
    marginTop: rhythm(1),
    marginBottom: 0,
    fontFamily: `Dosis`,
    fontWeight: 200,
  },
  navStyle: {
    display: `flex`,
    flexWrap: `wrap`,
    justifyContent: `space-between`,
    listStyle: `none`,
    padding: 0,
  },
}

const { fromGatsbyNode } = PostMappers
const { headerStyle, titleStyle, navStyle } = tagTemplateStyles

const Tag = ({ data, location }) => {
  const { allMarkdownRemark, site } = data
  const siteTitle = site.siteMetadata.title
  const siteDescription = site.siteMetadata.description
  const tag = location.pathname.split("/").pop()

  const allPosts =
    allMarkdownRemark && allMarkdownRemark.edges
      ? allMarkdownRemark.edges.map(fromGatsbyNode)
      : []
  const postsMatchingTag = allPosts.filter(
    ({ frontmatter }) => frontmatter.tags && frontmatter.tags.includes(tag)
  )

  return (
    <Layout location={location} title={siteTitle}>
      <SEO title={`Posts of tag ${tag}`} description={siteDescription} />

      <article>
        <header style={headerStyle}>
          <h2 style={titleStyle}>#{tag}</h2>
        </header>
        <section>
          <PostList posts={postsMatchingTag} />
          <nav>
            <ul style={navStyle}>
              <li>
                <Link to="/" rel="prev">
                  ← Home
                </Link>
              </li>
              <li>
                <Link to="/tags" rel="next">
                  All tags →
                </Link>
              </li>
            </ul>
          </nav>
        </section>
      </article>
    </Layout>
  )
}

export default Tag

export const pageQuery = graphql`
  query BlogPostByTag {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            description
            readingTime
            tags
          }
        }
      }
    }
  }
`
